/* eslint-disable */

import React from 'react';
import { getIconColor } from './helper';

const DEFAULT_STYLE = {
  display: 'block',
};

const IconPingguduixiangfenxi = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M930.112 903.488H93.888a8.512 8.512 0 0 1-8.576-8.576v-25.6c0-4.672 3.84-8.512 8.576-8.512h836.224c4.736 0 8.576 3.84 8.576 8.512v25.6c0 4.736-3.84 8.576-8.576 8.576z m-183.424-238.976H576a8.576 8.576 0 0 1-8.512-8.512v-25.6c0-4.736 3.84-8.512 8.512-8.512h170.688c4.672 0 8.512 3.84 8.512 8.512v25.6c0 4.736-3.84 8.512-8.512 8.512z m157.824-544H119.488a8.512 8.512 0 0 0-8.576 8.576v665.6c0 4.672 3.84 8.512 8.576 8.512h785.024c4.736 0 8.576-3.84 8.576-8.512v-665.6a8.512 8.512 0 0 0-8.576-8.576z m-563.2 149.376a93.888 93.888 0 1 1 0 187.712 93.888 93.888 0 0 1 0-187.712zM247.488 515.2c0-4.736 3.84-8.512 8.512-8.512h170.688c4.672 0 8.512 3.84 8.512 8.512v25.6c0 4.736-3.84 8.512-8.512 8.512H256a8.512 8.512 0 0 1-8.512-8.512v-25.6z m520.64-82.688L768 432.64v0.256l-16 16h-0.256l-68.096 68.032a8.512 8.512 0 0 1-12.032 0l-18.112-18.048a8.576 8.576 0 0 1 0-12.096l37.888-37.888h-54.144l-212.224 212.288a8.512 8.512 0 0 1-6.912 3.52H256a8.512 8.512 0 0 1-8.512-8.576v-25.6c0-4.736 3.84-8.512 8.512-8.512h147.84l212.224-212.224a8.512 8.512 0 0 1 6.912-3.52h70.848l-40.32-40.32a8.512 8.512 0 0 1 0-12.096l18.112-18.112a8.576 8.576 0 0 1 12.096 0l84.48 84.48c1.664 1.664 2.432 3.904 2.432 6.144 0 2.304-0.832 4.48-2.496 6.144z"
        fill={getIconColor(color, 0, '#FFFFFF')}
      />
    </svg>
  );
};

IconPingguduixiangfenxi.defaultProps = {
  size: 18,
};

export default IconPingguduixiangfenxi;
